<template>
  <div id="app" class="h100">

    <main-menu v-if="user.name" />

    <div class="app-content h100" :class="{ 'has-sidebar': user.name }">
      <router-view/>
    </div>

    <trial-expired-modal />
    <subscription-expired-modal />

    <ConfirmDeleteModal v-if="empty_invoice_notice"
                        class="info-notice"
                        :title="lang.facturi.emptyInvoiceTitle"
                        :message="lang.facturi.emptyInvoiceError"
                        :confirmLabel="lang.facturi.emptyInvoiceCta"
                        :hideCancel="true"
                        @confirm="Close_Empty_Invoice_Notice"
                        @cancel="Close_Empty_Invoice_Notice" />

    <recorder v-if="should_record" />
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import MainMenu from './components/main-menu'
  import TrialExpiredModal from './components/TrialExpiredModal'
  import SubscriptionExpiredModal from './components/Subscription_Expired_Modal'
  import Recorder from './components/Recorder.vue'
  import ConfirmDeleteModal from './components/ConfirmationModal.vue'

  // Routes where the session is recorded. Anything not listed here is NOT
  // recorded — keep this list tight, each entry costs storage and is a PII
  // surface on BE. `deviz` matches /deviz/:id (the interior view), NOT the
  // /devize list page.
  const RECORDED_ROUTES = [
    // 'deviz',
    'programari'
  ]

  // Fired once per browser session (sessionStorage flag, same tactic as the
  // error reporter's session id). Device/viewport data is stable, so there's
  // no point re-sending it on every page view.
  const DEVICE_SENT_KEY = 'analytics_device_sent'

  export default {
    name: 'app',
    computed: {
      ...mapState({
        user: state => state.auth.user
      }),
      ...mapGetters(['lang', 'empty_invoice_notice']),
      should_record () {
        return !!this.user.name && RECORDED_ROUTES.indexOf(this.$route.name) !== -1
      }
    },
    methods: {
      Close_Empty_Invoice_Notice () {
        this.$store.commit('SET_EMPTY_INVOICE_NOTICE', false)
      }
    },
    watch: {
      // immediate covers the cookie re-login on boot; the watch also fires
      // when the user logs in after App is already mounted.
      'user.name': {
        immediate: true,
        handler (name) {
          if (!name) return
          if (sessionStorage.getItem(DEVICE_SENT_KEY)) return
          sessionStorage.setItem(DEVICE_SENT_KEY, '1')
          this.$store.dispatch('track', { event: 'device_info' })
        }
      }
    },
    components: {
      MainMenu,
      TrialExpiredModal,
      SubscriptionExpiredModal,
      Recorder,
      ConfirmDeleteModal
    }
  }
</script>

<style lang="less">
  // On desktop the content column sits beside the fixed left sidebar.
  // On mobile there is no sidebar (the fixed top bar is used instead),
  // so no horizontal offset.
  .app-content.has-sidebar {
    @media only screen and (min-width: 1024px) {
      margin-left: var(--sidebar-width);
    }
  }
</style>
